export default __webpack_public_path__ + "assets/images/dd5f6cc6f9f9c74aef584cfc0800b2a5.svg";